module.exports = __webpack_public_path__ + "static/img/Confirm.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/christmasPC-2019/Confirm.png
// module id = OmI7
// module chunks = 1